import { push, replace } from 'connected-react-router'

import apiConfig from 'utilities/apiConfig'
import axios from 'axios'
import { fetchCampaign } from 'campaign/actions'
import { fetchGlobals } from 'actions/Global'
import { handleNetworkError } from 'actions/Error'
import kebabCase from 'lodash/kebabCase'
import { matchPath } from 'react-router'

export function fetchAllData(region) {
    return (dispatch) => {
        dispatch(resetProductDetails())
        dispatch(fetchAllProducts(region))
        dispatch(fetchCategories(region))
        dispatch(fetchSuppliers(region))
        dispatch(fetchRecommendations(region))
        dispatch(fetchBannersAndFeaturedProducts(region))
        dispatch(fetchMyProducts())
        dispatch(fetchCampaign())
        dispatch(fetchGlobals())
    }
}

export function attemptFetchStock() {
    return (dispatch, getState) => {
        dispatch({ type: 'FETCH_STOCK' })

        const state = getState()
        const deliveryDate = state.checkout.deliveryDate
        const region = state.region.slug

        if (!deliveryDate || !region) {
            return
        }

        const params = { region, deliveryDate }
        axios
            .get(`${process.env.API_URL}/api/fetch-stock`, { params })
            .then((response) => {
                if (response.data.error) {
                    dispatch({
                        type: 'FETCH_STOCK_FAILED',
                        payload: response.data.error,
                    })
                } else {
                    dispatch({
                        type: 'FETCH_STOCK_SUCCESS',
                        payload: response.data,
                    })
                }
            })
            .catch((err) => {
                console.error(err)
                dispatch({ type: 'FETCH_STOCK_FAILED' })
            })
    }
}

export function fetchAllProducts(region) {
    return (dispatch, getState) => {
        dispatch({ type: 'FETCH_ALL_PRODUCTS' })
        axios
            .get(`${process.env.API_URL}/${region}/api/v2/products`, apiConfig)
            .then((response) => {
                dispatch({
                    type: 'FETCH_ALL_PRODUCTS_SUCCESS',
                    payload: response.data.data,
                })
            })
            .catch((err) => {
                dispatch({ type: 'FETCH_ALL_PRODUCTS_FAILED', payload: err })
                if (!getState().products.products.length) {
                    dispatch(handleNetworkError(err, true))
                }
            })
    }
}

export function fetchRecommendations(region) {
    return (dispatch) => {
        dispatch({ type: 'FETCH_RECOMMENDATIONS' })
        axios
            .get(`${process.env.API_URL}/${region}/api/recommendations`, apiConfig)
            .then((response) => {
                dispatch({
                    type: 'FETCH_RECOMMENDATIONS_SUCCESS',
                    payload: response.data,
                })
            })
            .catch((err) => dispatch({ type: 'FETCH_RECOMMENDATIONS_FAILED', payload: err }))
    }
}

export function fetchBannersAndFeaturedProducts(region) {
    return (dispatch) => {
        dispatch({ type: 'FETCH_FRONT_PAGE_DATA' })
        axios
            .get(`${process.env.API_URL}/${region}/api/v1/front?limit=4`, apiConfig)
            .then((response) => {
                dispatch({
                    type: 'FETCH_FEATURED_PRODUCTS_SUCCESS',
                    payload: response.data.featured,
                })
                if (response.data.topBanner) {
                    dispatch({
                        type: 'FETCH_TOP_BANNER_ID_SUCCESS',
                        payload: response.data.topBanner,
                    })
                } else {
                    dispatch({
                        type: 'FETCH_TOP_BANNER_ID_FAILED',
                    })
                }

                if (response.data.bottomBanner) {
                    dispatch({
                        type: 'FETCH_BOTTOM_BANNER_ID_SUCCESS',
                        payload: response.data.bottomBanner,
                    })
                } else {
                    dispatch({
                        type: 'FETCH_BOTTOM_BANNER_ID_FAILED',
                    })
                }

                dispatch({
                    type: 'FETCH_RECOMMENDED_CATEGORY_FRONT',
                    payload: response.data.recommendedCategory,
                })
            })
            .catch((err) => dispatch({ type: 'FETCH_FRONT_PAGE_DATA_FAILED', payload: err }))
    }
}

export function fetchMyProducts() {
    return (dispatch, getState) => {
        if (!getState().user.isLoggedIn) return

        dispatch({ type: 'FETCH_MY_PRODUCTS' })
        axios
            .get(`${process.env.CORE_API}/deliveries/ordered-count`)
            .then((response) => {
                dispatch({
                    type: 'FETCH_MY_PRODUCTS_SUCCESS',
                    payload: response.data.map((p) => p.id),
                })
            })
            .catch((err) => dispatch({ type: 'FETCH_MY_PRODUCTS_FAILED', payload: err }))
    }
}

export function fetchCategories(region) {
    return (dispatch, getState) => {
        dispatch({ type: 'FETCH_CATEGORIES' })
        axios
            .get(`${process.env.API_URL}/${region}/api/v2/categories`, apiConfig)
            .then((response) => {
                dispatch({
                    type: 'FETCH_CATEGORIES_SUCCESS',
                    payload: response.data.data,
                })
            })
            .catch((err) => {
                dispatch({ type: 'FETCH_CATEGORIES_FAILED', payload: err })
                if (!getState().products.categories.length) {
                    dispatch(handleNetworkError(err, true))
                }
            })
    }
}

export function fetchSuppliers(region) {
    return (dispatch, getState) => {
        dispatch({ type: 'FETCH_SUPPLIERS' })
        axios
            .get(`${process.env.API_URL}/${region}/api/suppliers?includeDummy=0`, apiConfig)
            .then((response) =>
                dispatch({
                    type: 'FETCH_SUPPLIERS_SUCCESS',
                    payload: response.data.data,
                })
            )
            .catch((err) => {
                dispatch({ type: 'FETCH_SUPPLIERS_FAILED', payload: err })
                if (!getState().products.suppliers.length) {
                    dispatch(handleNetworkError(err, true))
                }
            })
    }
}

export function fetchProductDetails(id, region) {
    return (dispatch, getState) => {
        dispatch({ type: 'FETCH_PRODUCT_DETAILS' })
        axios
            .get(`${process.env.API_URL}/${region}/api/products/${id}`, apiConfig)
            .then((response) => {
                dispatch({
                    type: 'FETCH_PRODUCT_DETAILS_SUCCESS',
                    payload: response.data,
                })
            })
            .catch((err) => {
                dispatch({ type: 'FETCH_PRODUCT_DETAILS_FAILED', payload: err })
                if (!getState().products.productsWithDetails.id) {
                    dispatch(handleNetworkError(err))
                }
            })
    }
}

export function resetFilterAndSort() {
    return { type: 'RESET_PRODUCT_FILTER_AND_SORT' }
}

export function setFilterTags(filterTags) {
    return { type: 'SET_PRODUCT_FILTER_TAGS', payload: filterTags }
}

export function setSortBy(orderBy) {
    return { type: 'SET_PRODUCT_SORT_BY', payload: orderBy }
}

export function resetProductDetails() {
    return { type: 'RESET_PRODUCT_DETAILS' }
}

export function gotoProduct(product, productContext) {
    const { id, title } = product
    return (dispatch, getState) => {
        const productPath = { path: '/product/:productId' }
        const { pathname, state } = getState().router.location
        const isMobile = getState().ui.isMobile
        const isModal = state && state.modal && !isMobile
        const action = isModal && matchPath(pathname, productPath) ? replace : push

        dispatch({ type: 'SELECT_ITEM', payload: { product, productContext } })
        dispatch(
            action({
                pathname: `/product/${id}/${kebabCase(title)}`,
                state: { modal: true },
            })
        )
    }
}
